<app-feature-details-grid>
  <app-feature-list-container>
    <!-- heating circuit -->
    <app-feature-list-item
      data-ut-trv-heating-circuit
      *ngIf="!(isSrcStandalone$ | async)?.properties?.active?.value"
      [label]="'+COMMISSIONING.DEVICE_PANEL.HEATING_CIRCUIT.LABEL' | translate"
      [value]="
        installationService.getCircuitName(
          this.otherRoom?.properties?.heatingCircuit?.value + '' || null
        ) | async
      "
    >
    </app-feature-list-item>

    <!-- rooms.others.n.geofencing -->
    <ng-container *ngIf="geofencing$ | async | ready as feature">
      <app-feature-list-item
        data-at-room-geofencing
        *ngIf="feature?.properties?.active?.value"
        [label]="'+INSTALLATIONS.INSTALLATION.CIRCUIT.GEOFENCING' | translate"
        [value]="'+INSTALLATIONS.INSTALLATION.CIRCUIT.GEOFENCING_ACTIVE' | translate"
        [attr.data-feature]="feature.feature"
      >
      </app-feature-list-item>
    </ng-container>

    <!-- Target room temperature -->
    <!-- rooms.n.operating.programs.[normal/reduced/comfort/manual]Heating -->
    <ng-container *ngIf="heating$ | async | ready as feature; else noTargetRoomTemp">
      <app-feature-list-item
        data-at-room-set
        [label]="'+INSTALLATIONS.INSTALLATION.SRC.TARGET_ROOM_TEMPERATURE' | translate"
        [error]="feature | error"
        [isNgContent]="true"
        [editable]="true"
        [timestamp]="feature.timestamp | date: 'short'"
        [attr.data-feature]="feature.feature"
      >
        <ng-container
          *ngIf="
            (levelsCooling$ | async | ready) || (levelsHeating$ | async | ready);
            else operatingPrograms
          "
        >
          <div *ngIf="targetTemperature$ | async | ready as targetTemperature; else noValue">
            {{ feature | value2: featurePropertyKey.temperature }}
            {{ feature | unit: featurePropertyKey.temperature }}
          </div>
          <ng-template #noValue>
            <div>{{ NO_VALUE }}</div>
          </ng-template>
        </ng-container>
        <ng-template #operatingPrograms>
          <div>
            <div>
              {{ feature | value2: featurePropertyKey.temperature }}
              {{ feature | unit: featurePropertyKey.temperature }}
            </div>
          </div>
        </ng-template>

        <mat-icon
          class="edit-icon"
          appSrcModalManager="src-other-room-temperature-schedule-manager"
          [room]="otherRoom"
          (click)="installationService.selectedOtherRoomId$.next(this.otherRoomId)"
          gtm="onOpen"
          gtmAction="Multiple days selection dialog"
          gtmCategory="otherRoomsPanel"
        >
          edit
        </mat-icon>
      </app-feature-list-item>
    </ng-container>
    <ng-template #noTargetRoomTemp>
      <app-feature-list-item
        data-at-room-set
        [label]="'+INSTALLATIONS.INSTALLATION.SRC.TARGET_ROOM_TEMPERATURE' | translate"
        [isNgContent]="true"
      >
        <div>{{ NO_VALUE }}</div>
      </app-feature-list-item>
    </ng-template>

    <!-- active operating program -->
    <ng-container *ngIf="operatingState$ | async | ready as feature; else noHeatingProgram">
      <app-feature-list-item
        data-ut-program
        [label]="'+INSTALLATIONS.INSTALLATION.CIRCUIT.PROGRAM' | translate"
        [editable]="true"
        [isNgContent]="true"
        [attr.data-feature]="feature.feature"
      >
        <div>
          {{
            feature.properties?.reason?.value
              | translateOperatingState: feature.properties?.level?.value
          }}
        </div>
        <mat-icon
          class="edit-icon"
          appSrcModalManager="src-other-room-temperature-schedule-manager"
          [room]="otherRoom"
          (click)="installationService.selectedOtherRoomId$.next(this.otherRoomId)"
          gtm="onOpen"
          gtmAction="Multiple days selection dialog"
          gtmCategory="otherRoomsPanel"
        >
          edit
        </mat-icon>
      </app-feature-list-item>
    </ng-container>
    <ng-template #noHeatingProgram>
      <app-feature-list-item
        data-ut-program
        [label]="'+INSTALLATIONS.INSTALLATION.CIRCUIT.PROGRAM' | translate"
        [editable]="true"
        [isNgContent]="true"
      >
        <div>{{ NO_VALUE }}</div>
      </app-feature-list-item>
    </ng-template>
  </app-feature-list-container>
</app-feature-details-grid>
